import React, { useState } from "react";
import {
    Modal, Box, Typography, IconButton,
    Grid, Stack,
    Divider,
    Button,
    useMediaQuery,
    Paper,
    Chip,
    Skeleton,
    Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "../api/axiosConfig";
import Printing from "../utils/Printing";

import { useTheme } from "@mui/material/styles";

export default function PaymentResponse({ open, onClose, data }) {
    const [mPayCode, setMPayCode] = useState('')
    const [mres, setMres] = useState(null)
    const [printing, setPrinting] = useState(false)

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [errorMessage, setErrorMessage] = useState('')

    const formatDate = (value) => {
        if (!value) return value;

        // Check patterns: YYYY-MM-DD or YYYY-MM-DD HH:mm:ss
        const dateOnly = /^\d{4}-\d{2}-\d{2}$/;
        const dateTime = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;

        if (dateOnly.test(value)) {
            const d = new Date(value);
            return d.toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric",
            });
        }

        if (dateTime.test(value)) {
            const d = new Date(value);
            return d.toLocaleString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric",

            });
        }

        return value

    }

    // const handlePrint = async () => { 
    //     setErrorMessage('')
    //     try {

    //         setMres(null)
    //         const res = await axios.get(
    //             `/paydetail.php?paycode=${data.paycode}`,
    //         );
    //         setMres(res.data)
    //         const rawData = Printing.RawPrintingESCPOS(mres)
    //         console.log("RAW DATA:", rawData);
    //         await postRawDataToPrinter(rawData);
    //     } catch (error) {
    //         console.error("Error fetching payment details:", error);
    //         setErrorMessage("Error fetching payment details:", JSON.stringify(error));
    //     }
    // };

    const handlePrint = async () => {
        setErrorMessage("");

        try {
            setPrinting(true);
            const res = await axios.get(
                `/paydetail.php?paycode=${data.paycode}`
            );

            const paymentDetail = res.data;

            if (!paymentDetail) {
                throw new Error("Payment detail is empty");
            }

            setMres(paymentDetail); // for UI only

            const rawData = Printing.RawPrintingESCPOS(paymentDetail);

            if (!rawData) {
                throw new Error("Raw printing data is empty");
            }

            // console.log("RAW DATA:", rawData);

            await postRawDataToPrinter(rawData);

        } catch (error) {
            console.error("Print error:", error);

            setErrorMessage(
                error?.message || "Gagal memproses data cetak"
            );
        } finally {
            setPrinting(false);
        }
    };


    const postRawDataToPrinter = async (rawData) => {
        try {
            const resAPI = await axios.post(
                '/printing.php?action=create',
                { datatoprint: rawData }
            );
            alert('Cetak Nota sudah diantrikan. Pastikan printer dalam keadaan ON dan terhubung.');
            // console.log('Raw data sent to printer successfully.\n' + JSON.stringify(resAPI.data));
        } catch (error) {
            alert('Gagal mengirim data mentah ke printer.');
            // console.error('Error sending raw data to printer:', error);
        }
    }

    return (
        <Modal open={open} onClose={onClose} >
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: isMobile ? "stretch" : "center",
                    justifyContent: "center",
                    p: isMobile ? 0 : 2,
                    background: "rgba(2,6,23,0.35)",
                }}
            >
                <Box
                    sx={{
                        width: isMobile ? "100%" : 520,
                        bgcolor: "background.paper",
                        borderRadius: isMobile ? 0 : 4,
                        boxShadow: "0 24px 60px rgba(15,23,42,0.25)",
                        border: "1px solid",
                        borderColor: "divider",
                        p: isMobile ? 2 : 3,
                    }}
                >

                    {/* Header */}
                    <Box display="flex" justifyContent="space-between" alignItems="center"
                        sx={{
                            // background:  'linear-gradient(135deg, rgba(226,232,240,0.5), rgba(248,250,252,0.9))',
                            px: 2,
                            py: 1.5,
                            borderRadius: 0,
                            overflow: 'hidden',
                        }}
                    >
                        <Stack spacing={0.2}>
                            <Typography variant="h6" fontWeight={800}>
                                Transaksi Pembayaran
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                Ringkasan pembayaran dan detail cetak
                            </Typography>
                        </Stack>
                        <IconButton onClick={onClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    <Box mt={0} sx={{ display: "grid", gap: 1, p: isMobile ? 2 : 3, }}>
                        {/* <Typography>{JSON.stringify(data)}</Typography> */}
                        {data ? (
                            <>
                                <Grid container spacing={1}>
                                    <Grid item size={{ xs: 12, sm: 4 }}>
                                        <Paper elevation={0} sx={{ borderRadius: 2, 
                                            border: "1px solid",
                                             borderColor: "divider", py: 1, px: 2 }}>
                                            <Stack direction={'column'}>
                                                <Typography variant="caption" color="text.secondary">
                                                    Status
                                                </Typography>
                                                <Chip
                                                    variant="outlined"
                                                    label={data.success ? "SUKSES" : "GAGAL"}
                                                    color={data.success ? "success" : "error"}
                                                    size="small"
                                                    sx={{borderRadius:3,}}
                                                />
                                            </Stack>
                                        </Paper>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 8 }}>
                                        <Paper elevation={0} sx={{ borderRadius: 2, border: "1px solid", borderColor: "divider", py: 1, px: 2 }}>
                                            <Stack direction={'column'}>
                                                <Typography variant="caption" color="text.secondary">
                                                    PayCode
                                                </Typography>
                                                <Typography sx={{ fontSize: "16px", color: "text.primary", fontWeight: 700 }}>
                                                    {data.paycode}
                                                </Typography>
                                            </Stack>
                                        </Paper>
                                    </Grid>
                                </Grid>
                                <Divider />
                                <Box sx={{ display: 'grid', gap: 1, overflowY: 'auto', maxHeight: '300px' }}>
                                    {data.details?.paid?.length ? (
                                        data.details?.paid?.map((item, index) => (
                                            <Paper key={`${item.cardcode}-${index}`} elevation={0} sx={{
                                                py: 1, px: 2,
                                                border: '1px solid',
                                                borderColor: 'divider',
                                                background: 'background.paper',
                                                borderRadius: 2,
                                                "&:hover": {
                                                    borderColor: "#cbd5e1",
                                                    boxShadow: '0 6px 14px rgba(15,23,42,0.12)',
                                                    transform: "translateY(-1px)",
                                                },
                                            }}>
                                                <Grid container spacing={0.6}>
                                                    <Grid size={{ xs: 7 }} >
                                                        <Typography fontWeight={600}>
                                                            {item.cardyear}  {item.cardmonth}
                                                        </Typography>
                                                    </Grid>

                                                    <Grid size={{ xs: 5 }} >
                                                        <Typography fontSize={14}>
                                                            {item.amount}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Paper>
                                        ))
                                    ) : (
                                        <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: "1px dashed", borderColor: "divider" }}>
                                            <Typography color="text.secondary">Tidak ada detail pembayaran.</Typography>
                                        </Paper>
                                    )}
                                </Box>
                            </>
                        ) : (
                            <Typography>No data</Typography>
                        )}
                        <Divider />
                        <Stack direction={'row'} spacing={1}>
                            <Button variant="contained" color="success" onClick={handlePrint} disabled={printing}>
                                {printing ? "Processing..." : "Print"}
                            </Button>
                            <Button variant="outlined" onClick={onClose}>Tutup</Button>
                        </Stack>
                        {errorMessage ? (
                            <Alert severity="error" variant="outlined">
                                {errorMessage}
                            </Alert>
                        ) : (
                            <Alert severity="info" variant="outlined">
                                Klik Cetak untuk mulai mencetak. Klik Tutup untuk menutup.
                            </Alert>
                        )}
                        {/* <Box>
                    <Typography>{JSON.stringify(mres)}</Typography>
                    </Box> */}
                    </Box>
                </Box>
            </Box >
        </Modal >
    );
}
